var _circle, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAperture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-aperture",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 8,
    x2: 20.05,
    y2: 17.94
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 8,
    x2: 21.17,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.38,
    y1: 12,
    x2: 13.12,
    y2: 2.06
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 16,
    x2: 3.95,
    y2: 6.06
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 16,
    x2: 2.83,
    y2: 16
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 16.62,
    y1: 12,
    x2: 10.88,
    y2: 21.94
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAperture);
export default __webpack_public_path__ + "static/media/aperture.09da64237cef340d981a3cb3615e1308.svg";
export { ForwardRef as ReactComponent };